module.exports = __webpack_public_path__ + "img/visa.895af6cb.jpg";